<template>
    <div>
        <breadcrumbs class="mb-3" />
        <page-title :text="$t('page_titles.company_suppliers_page_title')" />
        <div class="d-flex flex-wrap mb-4">
            <v-btn variant="flat" :to="{name: 'companySupplier', params: {id: 0}}" class="bg-primary me-2 mb-2">
                {{ $t('new_supplier') }}
            </v-btn>
            <v-btn
                v-if="isTO1"
                variant="outlined"
                color="primary"
                class="me-2"
                :disabled="!emails.length"
                @click="emailModal = true"
            >
                {{ $t('send_email') }}
            </v-btn>
        </div>
        <suppliers-table
            :company-type="['HUB_SUPPLIER', 'INTERNAL_SUPPLIER']"
            relationship="SUPPLIER"
            @change-selected-emails="emails = $event"
            @change-selected-companies="selectedCompanies = $event"
            @change-companies="companies = $event"
        />
        <send-clients-email-modal v-model="emailModal" :emails="emails" @sent="$refs.table.selected = []" />
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import SuppliersTable from '@/components/account/SuppliersTable.vue'
    import CompanyAgenciesPage from '@/pages/account/CompanyAgenciesPage.vue'
    import PageTitle from '@/components/parts/PageTitle.vue'

    @Component({
        components: {
            SuppliersTable,
            PageTitle,
        },
        mixins: [CompanyAgenciesPage],
    })
    export class CompanySuppliersPage extends Vue {}

    export default CompanySuppliersPage
</script>
